import React from 'react';
import AppBar from "@mui/material/AppBar";
import { useTranslation } from 'react-i18next';


export default function TopBarHeader({elevation}) {
    const {t} = useTranslation()
    return (<div className="heightHeader">
        <header className="header">
            <AppBar component="nav" className="topBar"
                    elevation={elevation ? 4 : 0}
                    style={{
                        boxShadow: elevation
                            ? "0px 10px 15px rgba(61, 57, 53, 0.05)"
                            : undefined
                    }}>
                <div className="appBarContent">
                    <a className="headerImageLogo" rel="noreferrer" target="_blank" href={'https://k2g.ai/'}/>
                    <div className="headerBlockPhoneTitle">
                        <div className="headerTitleText" style={{
                                   maxWidth: "540px",
                                   textWrap: "wrap",
                                   marginTop: "12px",
                                   color: "#3198F6",
                                   lineHeight: "20px",
                                   marginLeft: "220px",
                        }}>
                            {t('logo_header')}
                            <a  
                                style={{fontWeight: '600'}} 
                                target='_blank'
                                rel='noopener noreferrer'
                                href={t('logo_header_link')}
                            >
                                {t('logo_header_link')}
                            </a>
                        </div>
                    </div>
                </div>
            </AppBar>
        </header>
    </div>)
};

